module.exports = __webpack_public_path__ + "img/help12_downlaod_page.f363900c.png";